import { Control, IControlArgs } from "../../business-objects/control/control.model";
import { AclCategoryControlConfig } from "./acl-category-control-config.model";

export interface IAclCategoryControlArgs extends IControlArgs {
    config: AclCategoryControlConfig;
}

const defaults = () => ({
    config: new AclCategoryControlConfig()
});

export class AclCategoryControl extends Control {
    config: AclCategoryControlConfig;

    constructor(data?: IAclCategoryControlArgs) {
        super({...defaults(), ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/acl-category-control.model.ts